export default __webpack_public_path__ + "static/media/near-east.70a44d49.png";